import { combineReducers } from "@reduxjs/toolkit";
import authentication from "./authentication";
import home from "./home";
import recentSearch from "./recentSearch";
import favouriteProducts from "./favourites";
import Bag from "./bag/apiThunk";
import orderHistory from "./orderHistory";

const rootReducer = combineReducers({
  authentication,
  home,
  recentSearch,
  favouriteProducts,
  Bag,
  orderHistory,
});

export default rootReducer;
